import { Component,Input,ViewEncapsulation } from '@angular/core';
import { AltinnApplication } from '../../../models/altinn-application/altinn-application';

@Component({
  selector: 'landing-page-awaiting-signature',
  templateUrl: './landing-page-awaiting-signature.component.html',
  styleUrls: ['./landing-page-awaiting-signature.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingPageAwaitingSignatureComponent {
  @Input({ required: true }) application!: AltinnApplication;

}
